"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeObjects = exports.flattenToPaths = exports.getAtPath = exports.setAtPath = exports.createForEach = exports.PATH_DELIM = void 0;
const lodash_1 = require("lodash");
const type_helpers_1 = require("./type.helpers");
exports.PATH_DELIM = '.';
function createForEach(items, setPath, callback) {
    return items.reduce((result, item) => {
        return setAtPath(result, callback(item), setPath(item));
    }, {});
}
exports.createForEach = createForEach;
/**
 * Sets the value at a specific data path on a data item
 * @param dataItem
 * @param newValue
 * @param dataPath
 */
function setAtPath(dataItem, newValue, dataPath = '') {
    const setNestedProp = (obj = {}, path, value) => {
        if (path) {
            const [first, ...rest] = path;
            return Object.assign(Object.assign({}, obj), { [first]: rest.length ? setNestedProp(obj[first], rest, value) : value });
        }
    };
    const dataPaths = dataPath.split(exports.PATH_DELIM);
    return setNestedProp(dataItem, dataPaths, newValue);
}
exports.setAtPath = setAtPath;
;
/**
 * Get nested data at path
 * @param dataItem
 * @param dataPath
 * @param explicitBoolean
 */
function getAtPath(dataItem, dataPath, explicitBoolean = false) {
    const dataPaths = dataPath ? dataPath.split(exports.PATH_DELIM) : [''];
    return dataPaths.reduce((finalValue, currentPath) => {
        const hasValue = explicitBoolean
            ? (0, type_helpers_1.isBooleanValue)(finalValue[currentPath]) ||
                !(0, type_helpers_1.isNullOrUndefined)(finalValue[currentPath])
            : !(0, type_helpers_1.isNullOrUndefined)(finalValue[currentPath]);
        return hasValue ? finalValue[currentPath] : '';
    }, dataItem);
}
exports.getAtPath = getAtPath;
/**
 * Given an object, with any depth, returns a single level object with
 * dot.notated dataPaths as the top level key, and the resolved value.
 *
 * Using this approach for data manipulation avoids recursion every time we
 * need to get a datapoint for a given dataPath, and offsets the performance
 * impact to the preparation stage.
 *
 * @param obj
 * @param parentKey
 */
function flattenToPaths(obj, parentKey = '') {
    let result = {};
    Object.keys(obj).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
            const currentKey = parentKey ? `${parentKey}.${key}` : key;
            if ((typeof obj[key] === 'object' && obj[key] !== null) && !Array.isArray(obj[key])) {
                const nested = flattenToPaths(obj[key], currentKey);
                result = Object.assign(Object.assign({}, result), nested);
            }
            else {
                result[currentKey] = obj[key];
            }
        }
    });
    return result;
}
exports.flattenToPaths = flattenToPaths;
/**
 * Merges two or more objects together to create a new object.
 * @param objects
 */
function mergeObjects(objects) {
    return (0, lodash_1.merge)({}, ...objects);
}
exports.mergeObjects = mergeObjects;
